(function () {
  var WIDGET = 'https://judge.me/api/v1/widgets/all_reviews_page.json';
  var FEED_PAGE_LENGTH = 20;
  /* text-only reviews shorter than this ("ok", "👍") are not shown */
  var MIN_TEXT_LENGTH = 20;

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function escapeText(value) {
    var node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  }

  function starSvg(className) {
    return (
      '<svg class="' +
      (className || 'rr-google-reviews__star') +
      '" viewBox="0 0 20 20" aria-hidden="true" focusable="false">' +
      '<path fill="currentColor" d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.9 5.06 16.71l.94-5.5-4-3.9 5.53-.8z"/>' +
      '</svg>'
    );
  }

  function starsHtml(count) {
    var html = '';
    var i;
    for (i = 0; i < count; i += 1) html += starSvg();
    return html;
  }

  function formatDate(value, locale) {
    if (!value) return '';
    var date = typeof value === 'number' ? new Date(value * 1000) : new Date(value);
    if (isNaN(date.getTime())) return '';
    try {
      return date.toLocaleDateString(locale || undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (err) {
      return date.toISOString().slice(0, 10);
    }
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  function masterPictureUrl(review) {
    var pics = (review && review.pictures_urls) || [];
    var first = pics[0];
    var url = '';
    if (!first) return '';
    if (typeof first === 'string') url = first;
    else if (first && typeof first === 'object') {
      url = first.original || first.huge || first.hidden || first.zoom || '';
    }
    return url ? url.split('?')[0] : '';
  }

  function sizedPictureUrl(master, width) {
    if (!master) return '';
    try {
      var parsed = new URL(master, window.location.href);
      parsed.searchParams.set('width', String(width));
      parsed.searchParams.set('quality', '85');
      return parsed.toString();
    } catch (err) {
      return master + (master.indexOf('?') === -1 ? '?' : '&') + 'width=' + width + '&quality=85';
    }
  }

  function pictureSet(review) {
    var master = review && review.masterUrl ? review.masterUrl : masterPictureUrl(review);
    if (!master) return null;
    return {
      src: sizedPictureUrl(master, 1200),
      srcset:
        sizedPictureUrl(master, 800) +
        ' 800w, ' +
        sizedPictureUrl(master, 1200) +
        ' 1200w, ' +
        sizedPictureUrl(master, 1600) +
        ' 1600w',
      sizes: '(min-width: 750px) 25vw, 50vw'
    };
  }

  function probeImage(url) {
    return new Promise(function (resolve, reject) {
      if (!url) {
        reject(new Error('empty'));
        return;
      }
      var img = new Image();
      var done = false;
      var timer = setTimeout(function () {
        if (done) return;
        done = true;
        reject(new Error('timeout'));
      }, 3000);
      img.onload = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        if (img.naturalWidth < 200 || img.naturalHeight < 200) reject(new Error('tiny'));
        else resolve(url);
      };
      img.onerror = function () {
        if (done) return;
        done = true;
        clearTimeout(timer);
        reject(new Error('error'));
      };
      img.src = url;
    });
  }

  function resolvePhoto(review) {
    var set = pictureSet(review);
    if (!set) return Promise.reject(new Error('no urls'));
    return probeImage(set.src).then(function (url) {
      review.photoUrl = url;
      review.photoSrcset = set.srcset;
      review.photoSizes = set.sizes;
      return url;
    });
  }

  function productPictureUrl(review) {
    var url = (review && (review.product_pictures_url || review.product_variant_image_url)) || '';
    return url ? String(url).split('?')[0] : '';
  }

  function normalizeReview(review) {
    var own = masterPictureUrl(review);
    return {
      rating: Number(review.rating),
      reviewer_name: review.reviewer_name,
      text: review.body || '',
      created_at: review.created_at,
      verified: !!review.verified_buyer,
      masterUrl: own || productPictureUrl(review),
      productPhoto: !own,
      productTitle: review.product_title || ''
    };
  }

  function isPhotoFiveStar(review) {
    return review && Number(review.rating) === 5 && !!masterPictureUrl(review);
  }

  /* 5 stars, no customer photo, a real sentence, and a product photo to show instead */
  function isTextFiveStar(review) {
    return (
      review &&
      Number(review.rating) === 5 &&
      !masterPictureUrl(review) &&
      String(review.body || '').trim().length >= MIN_TEXT_LENGTH &&
      !!productPictureUrl(review)
    );
  }

  /* "Only reviews of products named …": checked on the product name and link */
  function matchesProducts(review, search) {
    if (!search) return true;
    var title = String(review.product_title || '').toLowerCase();
    var url = String(review.product_url || '').toLowerCase().replace(/-/g, ' ');
    return search
      .toLowerCase()
      .split(',')
      .some(function (term) {
        term = term.trim();
        return !!term && (title.indexOf(term) !== -1 || url.indexOf(term) !== -1);
      });
  }

  function pickReviews(reviews, opts) {
    return (reviews || [])
      .filter(function (review) {
        if (!matchesProducts(review, opts.search)) return false;
        return isPhotoFiveStar(review) || (opts.includeText && isTextFiveStar(review));
      })
      .map(normalizeReview);
  }

  function fetchJson(url) {
    return fetch(url, {
      method: 'GET',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function loadReviewsPage(shopDomain, token, page, search) {
    var params = new URLSearchParams();
    params.set('platform', 'shopify');
    params.set('shop_domain', shopDomain);
    params.set('api_token', token);
    params.set('json_request', 'true');
    params.set('review_type', 'all-reviews');
    params.set('review_source', 'all_sources');
    params.set('per_page', String(FEED_PAGE_LENGTH));
    params.set('page', String(page));
    params.set('sort_by', 'pictures_first');
    params.set('filter_rating', '5');
    params.set('add_header_counts', 'true');
    if (search) params.set('search', search.split(',')[0].trim());
    return fetchJson(WIDGET + '?' + params.toString());
  }

  function bindExpand(card, textEl, moreEl, lines) {
    if (!textEl || !moreEl) return;
    textEl.style.setProperty('--rr-gr-lines', String(lines || 3));
    textEl.classList.add('is-clamped');
    requestAnimationFrame(function () {
      if (textEl.scrollHeight <= textEl.clientHeight + 2) {
        moreEl.hidden = true;
        return;
      }
      moreEl.hidden = false;
      moreEl.addEventListener('click', function () {
        var expanded = textEl.classList.toggle('is-clamped') === false;
        moreEl.textContent = expanded ? moreEl.getAttribute('data-less') : moreEl.getAttribute('data-more');
      });
    });
  }

  function renderCard(review, strings, locale, lines) {
    var article = document.createElement('article');
    article.className = 'rr-google-reviews__card' + (review.productPhoto ? ' rr-google-reviews__card--product-photo' : '');
    var photo = escapeText(review.photoUrl);
    var srcset = escapeText(review.photoSrcset || '');
    var sizes = escapeText(review.photoSizes || '(min-width: 750px) 25vw, 50vw');
    var name = escapeText(review.reviewer_name || strings.anonymous);
    var date = escapeText(formatDate(review.created_at, locale));
    var text = escapeText(review.text || '');
    article.innerHTML =
      '<img class="rr-google-reviews__photo" src="' +
      photo +
      '"' +
      (srcset ? ' srcset="' + srcset + '"' : '') +
      ' sizes="' +
      sizes +
      '" alt="' +
      (review.productPhoto ? escapeText(review.productTitle) : '') +
      '" width="800" height="800" decoding="async">' +
      '<div class="rr-google-reviews__body">' +
      (strings.showProduct && review.productTitle
        ? '<p class="rr-google-reviews__product">' + escapeText(review.productTitle) + '</p>'
        : '') +
      '<p class="rr-google-reviews__name">' +
      name +
      '</p>' +
      '<div class="rr-google-reviews__meta">' +
      (strings.verified && review.verified ? '<span class="rr-google-reviews__verified">' + escapeText(strings.verified) + '</span>' : '') +
      (date ? '<span>' + date + '</span>' : '') +
      '</div>' +
      '<div class="rr-google-reviews__stars" role="img" aria-label="5/5">' +
      starsHtml(5) +
      '</div>' +
      '<p class="rr-google-reviews__text">' +
      text +
      '</p>' +
      '<button type="button" class="rr-google-reviews__more" hidden data-more="' +
      escapeText(strings.more) +
      '" data-less="' +
      escapeText(strings.less) +
      '">' +
      escapeText(strings.more) +
      '</button>' +
      '</div>';
    bindExpand(article, qs(article, '.rr-google-reviews__text'), qs(article, '.rr-google-reviews__more'), lines);
    return article;
  }

  function updateSummary(root, feed) {
    var ratingEl = qs(root, '[data-rr-gr-rating]');
    var fromEl = qs(root, '[data-rr-gr-from]');
    var starsEl = qs(root, '[data-rr-gr-stars]');
    var rating = feed && feed.average_rating != null ? Number(feed.average_rating) : NaN;
    var count = feed && feed.number_of_reviews != null ? String(feed.number_of_reviews) : '';

    if (ratingEl && !isNaN(rating)) ratingEl.textContent = rating.toFixed(1);
    if (fromEl && count) {
      fromEl.textContent = (fromEl.getAttribute('data-template') || fromEl.textContent).replace('__COUNT__', count);
    }
    if (starsEl && !isNaN(rating)) {
      starsEl.style.setProperty('--rr-gr-fill', Math.max(0, Math.min(100, (rating / 5) * 100)).toFixed(2) + '%');
    }
  }

  function evenAtLeast(n, fallback) {
    var v = parseInt(n, 10);
    if (isNaN(v) || v < 2) v = fallback;
    if (v % 2) v += 1;
    return v;
  }

  function initialCount(root) {
    if (isDesktop()) return parseInt(root.getAttribute('data-max-desktop'), 10) || 4;
    return evenAtLeast(root.getAttribute('data-max-mobile'), 4);
  }

  function loadMoreCount(root) {
    if (isDesktop()) return parseInt(root.getAttribute('data-load-more'), 10) || 4;
    return evenAtLeast(root.getAttribute('data-load-more-mobile'), 4);
  }

  function hasMoreToShow(root) {
    var state = root._rrGr;
    if (!state) return false;
    return (
      state.usable.length > state.shown ||
      state.probeIndex < state.candidates.length ||
      state.feedHasMore
    );
  }

  function syncLoadMore(root) {
    var actions = qs(root, '[data-rr-gr-actions]');
    var button = qs(root, '[data-rr-gr-load-more]');
    if (!actions) return;
    var show = hasMoreToShow(root);
    actions.hidden = !show;
    if (button) button.disabled = !!root._rrGrLoadingMore;
  }

  function paintGrid(root, strings, locale, lines) {
    var grid = qs(root, '[data-rr-gr-grid]');
    var state = root._rrGr;
    if (!grid || !state) return;

    var want = Math.min(state.shown || initialCount(root), state.usable.length);

    var slice = state.usable.slice(0, want);
    grid.innerHTML = '';
    if (!slice.length) {
      var status = document.createElement('p');
      status.className = 'rr-google-reviews__status';
      status.textContent = strings.empty;
      grid.appendChild(status);
      syncLoadMore(root);
      return;
    }
    slice.forEach(function (review) {
      grid.appendChild(renderCard(review, strings, locale, lines));
    });
    syncLoadMore(root);
  }

  function appendCards(root, from, to, strings, locale, lines) {
    var grid = qs(root, '[data-rr-gr-grid]');
    var state = root._rrGr;
    if (!grid || !state) return;
    state.usable.slice(from, to).forEach(function (review) {
      grid.appendChild(renderCard(review, strings, locale, lines));
    });
    syncLoadMore(root);
  }

  function ensureUsable(root, want) {
    var state = root._rrGr;
    if (!state) return Promise.resolve([]);

    function step() {
      if (state.usable.length >= want) return Promise.resolve(state.usable);

      if (state.probeIndex < state.candidates.length) {
        var review = state.candidates[state.probeIndex];
        state.probeIndex += 1;
        return resolvePhoto(review)
          .then(function (photoUrl) {
            review.photoUrl = photoUrl;
            state.usable.push(review);
            return step();
          })
          .catch(function () {
            return step();
          });
      }

      if (!state.feedHasMore || state.fetchingFeed) {
        return Promise.resolve(state.usable);
      }

      state.fetchingFeed = true;
      var nextPage = state.feedPage + 1;
      return loadReviewsPage(state.shopDomain, state.token, nextPage, state.opts.search)
        .then(function (json) {
          state.fetchingFeed = false;
          state.feedPage = nextPage;
          var fresh = pickReviews(json && json.reviews, state.opts);
          var totalPages = json && json.total_pages ? Number(json.total_pages) : nextPage;
          if (!fresh.length || nextPage >= totalPages) state.feedHasMore = false;
          if (!fresh.length) return state.usable;
          state.candidates = state.candidates.concat(fresh);
          return step();
        })
        .catch(function () {
          state.fetchingFeed = false;
          state.feedHasMore = false;
          return state.usable;
        });
    }

    if (state.filling && state.fillingWant >= want) return state.filling;
    state.fillingWant = want;
    state.filling = step().then(function (usable) {
      if (state.fillingWant === want) state.filling = null;
      return usable;
    });
    return state.filling;
  }

  function init(root) {
    if (!root || root.getAttribute('data-rr-gr-ready') === 'true') return;
    root.setAttribute('data-rr-gr-ready', 'true');

    var grid = qs(root, '[data-rr-gr-grid]');
    if (!grid) return;

    var shopDomain = root.getAttribute('data-shop-domain');
    var token = root.getAttribute('data-api-token');
    var lines = parseInt(root.getAttribute('data-lines'), 10) || 3;
    var locale = root.getAttribute('data-locale') || document.documentElement.lang || 'el';
    var strings = {
      verified: root.getAttribute('data-label-verified') || '',
      more: root.getAttribute('data-label-more') || '',
      less: root.getAttribute('data-label-less') || '',
      loading: root.getAttribute('data-label-loading') || '',
      empty: root.getAttribute('data-label-empty') || '',
      anonymous: root.getAttribute('data-label-anonymous') || ''
    };
    var opts = {
      search: (root.getAttribute('data-search') || '').trim(),
      includeText: root.getAttribute('data-include-text') === 'true'
    };
    strings.showProduct = !!opts.search;

    if (!shopDomain || !token) return;

    var status = document.createElement('p');
    status.className = 'rr-google-reviews__status';
    status.textContent = strings.loading;
    if (!grid.querySelector('.rr-google-reviews__card')) grid.appendChild(status);

    loadReviewsPage(shopDomain, token, 1, opts.search)
      .then(function (feed) {
        if (!opts.search) updateSummary(root, feed || {});

        var candidates = pickReviews(feed && feed.reviews, opts);
        var totalPages = feed && feed.total_pages ? Number(feed.total_pages) : 1;

        root._rrGr = {
          opts: opts,
          token: token,
          shopDomain: shopDomain,
          candidates: candidates,
          usable: [],
          probeIndex: 0,
          shown: 0,
          feedPage: 1,
          feedHasMore: totalPages > 1,
          fetchingFeed: false,
          filling: null,
          fillingWant: 0
        };

        var first = initialCount(root);
        return ensureUsable(root, first).then(function () {
          root._rrGr.shown = Math.min(first, root._rrGr.usable.length);
          paintGrid(root, strings, locale, lines);
          ensureUsable(root, Math.max(first + loadMoreCount(root), 12)).then(function () {
            syncLoadMore(root);
          });
        });
      })
      .catch(function () {
        if (grid.querySelector('.rr-google-reviews__card')) {
          if (status.parentNode) status.remove();
          return;
        }
        status.textContent = strings.empty;
      });

    var loadBtn = qs(root, '[data-rr-gr-load-more]');
    if (loadBtn && !loadBtn._rrGrBound) {
      loadBtn._rrGrBound = true;
      loadBtn.addEventListener('click', function () {
        if (!root._rrGr || root._rrGrLoadingMore) return;
        var from = root._rrGr.shown;
        var want = from + loadMoreCount(root);
        root._rrGrLoadingMore = true;
        syncLoadMore(root);
        ensureUsable(root, want).then(function () {
          var to = Math.min(want, root._rrGr.usable.length);
          appendCards(root, from, to, strings, locale, lines);
          root._rrGr.shown = to;
          root._rrGrLoadingMore = false;
          syncLoadMore(root);
          if (hasMoreToShow(root)) {
            ensureUsable(root, to + loadMoreCount(root)).then(function () {
              syncLoadMore(root);
            });
          }
        });
      });
    }

    if (!root._rrGrMq) {
      root._rrGrMq = window.matchMedia('(min-width: 750px)');
      root._rrGrMq.addEventListener('change', function () {
        if (!root._rrGr) return;
        root._rrGr.shown = initialCount(root);
        ensureUsable(root, root._rrGr.shown).then(function () {
          root._rrGr.shown = Math.min(root._rrGr.shown, root._rrGr.usable.length);
          paintGrid(root, strings, locale, lines);
        });
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-rr-google-reviews]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-rr-google-reviews]');
    if (root) {
      root.removeAttribute('data-rr-gr-ready');
      init(root);
    }
  });
})();
